import copy from 'copy-to-clipboard';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

export async function copyToClipboard(text: string, { translate }: UtilityContext['i18n']): Promise<boolean> {
	// TODO different message for desktop?
	const message = translate('fe.components.share_buttons.mobile_copy_text');
	return copy(text, { format: 'text/plain', message, fallbackToPrompt: true });
}
